import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { UserManagementEffect } from "./effect";
import { UserManagementReducer } from "./reducer";

@NgModule({
  imports: [
    EffectsModule.forFeature([UserManagementEffect]),
    StoreModule.forFeature("userManagement", UserManagementReducer),
  ],
})
export class UserManagementStoreModule {}

export const userList = (store: any) =>
  store && store.userManagement && store.userManagement.userList;
export const userByFieldList = (store: any) =>
  store && store.userManagement && store.userManagement.userByFieldList;
export const userById = (store: any) =>
  store && store.userManagement && store.userManagement.userById;
export const addUserResponse = (store: any) =>
  store && store.userManagement && store.userManagement.addUserResponse;
export const updateUserResponse = (store: any) =>
  store && store.userManagement && store.userManagement.updateUserResponse;
export const deleteUserResponse = (store: any) =>
  store && store.userManagement && store.userManagement.deleteUserResponse;
export const userListByPartnerId = (store: any) =>
  store && store.userManagement && store.userManagement.userListByPartnerId;
export const partnersList = (store: any) =>
  store && store.userManagement && store.userManagement.partnersList;
export const adminsList = (store: any) =>
  store && store.userManagement && store.userManagement.adminsList;
